import React, { useState } from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import StyledButton from '../Common/StyledButton';
import CustomModal from '../Common/CustomModal';
import CustomizeActivityModal from './CustomizeActivityModal';
import { ACTIVITY_LIBRARY_ROUTE } from '../../utils/routes';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../types/commonTypes';

function EmptyActivityLibrary() {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);
  const location = useLocation();
  const isActivityLibraryPath = location.pathname === ACTIVITY_LIBRARY_ROUTE;
  const navigate = useNavigate();
  const theme = useTheme();
  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  const closeModel = () => {
    setModalOpen(false);
  };

  const handleClick = () => {
    if (isActivityLibraryPath) {
      setModalOpen(true);
    } else {
      navigate(ACTIVITY_LIBRARY_ROUTE);
    }
  };

  return (
    <>
      <Grid
        display="flex"
        flexDirection="column"
        gap="36px"
        alignItems="center"
        justifyContent="center"
        p={4}
        bgcolor="#fff"
        height="100%"
        boxShadow={theme.borderStyles.cardBorders}
        borderRadius="10px"
      >
        <img src="/assets/icons/clipboard-remove.svg" alt="clipboard-remove" />
        <Grid maxWidth={384} gap={2} display="flex" flexDirection="column" textAlign="center">
          <Typography variant="title2Bold" color="primary">
            {t('activityLibrary.empty.title')}
          </Typography>
          {isActivityLibraryPath && (
            <Typography variant="bodyRegular" color="primary">
              {t('activityLibrary.empty.description')}
            </Typography>
          )}
        </Grid>
        {checkPermissions(UserPermissionType.ACTIVITY_LIBRARY_MODULE_CREATE_ACTIVITY_LIBRARY) && (
          <StyledButton paddingX={80} onClick={handleClick} endIcon={!isActivityLibraryPath}>
            {isActivityLibraryPath
              ? t('activityLibrary.empty.button')
              : t('activityLibrary.empty.goToActivityLibrary')}
          </StyledButton>
        )}
      </Grid>
      {isModalOpen && (
        <CustomModal isOpen={isModalOpen} xs={11}>
          <CustomizeActivityModal closeModel={closeModel} isEditMode={false} />
        </CustomModal>
      )}
    </>
  );
}

export default EmptyActivityLibrary;
